
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-leadership/[slug]",
      function () {
        return require("private-next-pages/our-leadership/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/our-leadership/[slug]"])
      });
    }
  